<template>
  <div>
    Notes
  </div>
</template>

<script>
export default {

}
</script>
